module.exports = __webpack_public_path__ + "static/media/haute8C.5db864f9.jpg";